import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "authentication"

  connect() {
    this.previousAuthenticated = undefined
    this.syncAuth({ initial: true })
    document.addEventListener("turbo:load", this.boundSyncAuth)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundSyncAuth)
  }

  syncAuth(options = {}) {
    const initial = options.initial === true
    // Pequeño delay: el bridge native puede no estar listo inmediatamente tras Turbo/navigation.
    // Ref: gists en comentarios del post de Joe Masilotti sobre auth.
    requestAnimationFrame(() => {
      const authenticated = this.bridgeElement.bridgeAttribute("authenticated") === "true"
      const role = this.bridgeElement.bridgeAttribute("role") || ""
      if (authenticated) {
        this.send("signIn", { role })
        this.previousAuthenticated = true
        return
      }
      if (initial || this.previousAuthenticated === true) {
        this.send("signOut")
      }
      this.previousAuthenticated = false
    })
  }

  get boundSyncAuth() {
    return this._boundSyncAuth ??= () => this.syncAuth({ initial: false })
  }
}
